/**
 * Shared year constants used by SchoolDetailPage and SchoolLandingPicker.
 *
 * WI-29: extracted from SchoolDetailPage so both components use the same
 * target-year range without duplication.
 *
 * WI-36: trimmed to exactly 4 years — currentYear through currentYear+3.
 * No past years (years_out < 0 have no roster signal) and no years beyond +3
 * (years_out > 3 are beyond the FR cohort window). Computed at module load time
 * so the range shifts each January 1 automatically.
 */
const CURRENT_YEAR = new Date().getFullYear();

/** The 4 selectable graduation years: [currentYear, currentYear+1, currentYear+2, currentYear+3]. */
export const TARGET_YEAR_OPTIONS: readonly number[] = Object.freeze(
  Array.from({ length: 4 }, (_, i) => CURRENT_YEAR + i)
);
